export type {default as ColorType} from './colors'
export enum JURISDICTION_TYPE {
    ADGM='ADGM',
    DELAWARE = 'DELAWARE',
    CAYMAN = 'CAYMAN'
}
export enum ITEM_CODES{
    CHANGE_NAME_CAYMAN = "CHANGE_NAME_CAYMAN"
}